import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosDROPPAdmin } from "../../../services/api";
import {
  GET_ANALYTICS,
  GET_ANALYTICS_COUNTS,
  GET_SHOP_VISIT_COUNTS,
} from "../../../constants/url_helpers";

export const getAllAnalyticsCounts = createAsyncThunk(
  "analytics/getAllAnalyticsCounts",
  async (payload, thunk) => {
    try {
      const res = await axiosDROPPAdmin.get(GET_ANALYTICS_COUNTS, payload);
      let json = await res.data;

      return json;
    } catch (e) {
      return thunk.rejectWithValue(e?.response?.data);
    }
  }
);

export const getAnalytics = createAsyncThunk(
  "analytics/getAnalytics",
  async (payload, thunk) => {
    try {
      const res = await axiosDROPPAdmin.post(GET_ANALYTICS, payload);
      let json = await res.data;

      return json;
    } catch (e) {
      return thunk.rejectWithValue(e?.response?.data);
    }
  }
);

export const getAnalyticsShopDetails = createAsyncThunk(
  "analytics/getAnalyticsShopDetails",
  async (payload, thunk) => {
    try {
      const res = await axiosDROPPAdmin.post(GET_SHOP_VISIT_COUNTS, payload);
      return res?.data;
    } catch (e) {
      return thunk.rejectWithValue(e?.response?.data);
    }
  }
);
